import { useEffect, useState } from "react";
import { useNotificationContext } from "contexts/NotificationContext";
import { useParams } from "react-router-dom";
import { ITripDetailResponse } from "models/trips";
import { fetchTripByIdApi } from "api/trips";
import { fetchDriverByIdApi } from "api/driver";

export default function useTripDetail() {
  const id: string = useParams().id!;
  const { showError } = useNotificationContext();
  const [data, setData] = useState<{
    loading: boolean;
    data?: ITripDetailResponse;
  }>({
    loading: true,
  });

  useEffect(() => {
    fetchData();
  }, [id]); // eslint-disable-line

  const fetchData = async () => {
    setData({ loading: true });
    const { data: tripData, error } = await fetchTripByIdApi(id);
    if (tripData?.data) {
      // Log to see what's in the trip response
      console.log("Trip data:", tripData.data);
      console.log("Trip driver object:", tripData.data.driver);
      
      // Check if app_version is already in the trip response
      if ((tripData.data.driver as any).app_version) {
        console.log("App version found in trip response:", (tripData.data.driver as any).app_version);
      } else {
        // Fetch driver details separately to get app_version
        if (tripData.data.driver_id) {
          const { data: driverData } = await fetchDriverByIdApi(tripData.data.driver_id);
          if (driverData?.data) {
            // Log to see what's in the driver response
            console.log("Full driver data from API:", driverData.data);
            console.log("Driver app_version:", driverData.data.app_version);
            
            // Merge app_version into trip driver object
            tripData.data.driver = {
              ...tripData.data.driver,
              app_version: driverData.data.app_version,
            };
          }
        }
      }
      setData({ loading: false, data: tripData.data });
    } else showError(error!.message);
  };

  return {
    data,
  };
}
